import { CIcon } from '~/icons/types'

export const ciHourglass: CIcon = {
  width: 15,
  height: 21,
  paths: [
    {
      d:
        'M2.085 0H0v1h1.5A5.666 5.666 0 0 0 1 3.319c0 2.15 1.479 4.294 3.545 6.092a1.544 1.544 0 0 1 .62 1.089 1.543 1.543 0 0 1-.62 1.089C2.479 13.387 1 15.53 1 17.68c.001.8.171 1.59.5 2.32H0v1h15v-1h-1.516A5.595 5.595 0 0 0 14 17.681c0-2.15-1.479-4.294-3.545-6.092a1.543 1.543 0 0 1-.62-1.089 1.543 1.543 0 0 1 .62-1.089C12.521 7.613 14 5.47 14 3.32A5.593 5.593 0 0 0 13.484 1H15V0H2.085Zm10.292 1c.407.705.622 1.505.623 2.32 0 1.645-1.137 3.54-3.201 5.337a2.432 2.432 0 0 0-.965 1.843 2.435 2.435 0 0 0 .965 1.844c2.064 1.796 3.2 3.691 3.2 5.337 0 .814-.214 1.614-.621 2.319H2.624A4.68 4.68 0 0 1 2 17.68c0-1.645 1.137-3.54 3.201-5.337a2.432 2.432 0 0 0 .965-1.843 2.435 2.435 0 0 0-.965-1.844C3.137 6.86 2 4.965 2 3.32A4.68 4.68 0 0 1 2.623 1h9.754ZM3.102 16.925c.2-.779.68-1.456 1.35-1.9l2.593-1.722a.823.823 0 0 1 .91 0l2.594 1.722a3.248 3.248 0 0 1 1.45 2.656c0 .451-.085.898-.249 1.319h-8.5A3.713 3.713 0 0 1 3 17.68a3.05 3.05 0 0 1 .102-.755Z',
      fill: '#fff'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'hourglass',
  type: 'regular'
}
